import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { booleanQueryParam } from "../common/query-params.js";
export const deviceTypeEnum = z.enum([
    "mobile",
    "tablet",
    "robot",
    "camera",
    "manual_upload",
    "api",
]);
export const deviceInfo = z.object({
    id: z.string().uuid(),
    storeId: z.string().uuid().nullable(),
    storeName: z.string().nullable(),
    deviceType: deviceTypeEnum,
    serial: z.string().nullable(),
    model: z.string().nullable(),
    osName: z.string().nullable(),
    osVersion: z.string().nullable(),
    appVersion: z.string().nullable(),
    softwareVersion: z.string().nullable(),
    firmwareVersion: z.string().nullable(),
    isActive: z.boolean(),
    config: z.record(z.unknown()),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const createDeviceRequest = z.object({
    storeId: z.string().uuid().nullish(),
    deviceType: deviceTypeEnum,
    serial: z.string().max(255).nullish(),
    model: z.string().max(255).nullish(),
    osName: z.string().max(64).nullish(),
    osVersion: z.string().max(64).nullish(),
    appVersion: z.string().max(64).nullish(),
    softwareVersion: z.string().max(64).nullish(),
    firmwareVersion: z.string().max(64).nullish(),
    isActive: z.boolean().default(true),
    config: z.record(z.unknown()).default({}),
    metadata: z.record(z.unknown()).default({}),
});
export const updateDeviceRequest = createDeviceRequest.partial().refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const listDevicesQuery = paginationQuerySchema.extend({
    storeId: z.string().uuid().optional(),
    deviceType: deviceTypeEnum.optional(),
    isActive: booleanQueryParam.optional(),
});
export const devicesListResponse = pagedResponse(deviceInfo);
export const archiveDeviceResponse = z.object({ ok: z.literal(true) });
//# sourceMappingURL=capture-devices.schemas.js.map